export const UPDATE_TOKEN = 'UPDATE_TOKEN';
export function updateToken({ userId }) {
    return { type: UPDATE_TOKEN, userId };
}
